export { default as MetaDay } from "./MetaDay.component";
